<p-toast></p-toast>

<section *ngIf="productosPageInformacion" class="card">
    <h2 style="text-align: center;">Productos</h2>
    <p-toolbar styleClass="mb-2 gap-1">
        <ng-template pTemplate="center">
            <form [formGroup]="busquedaForm" (ngSubmit)="onSubmit()" class="p-fluid grid">

                <div class="field col-12 md:col-4">
                    <input id="firstname" pInputText type="text"
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        placeholder="Codigo" formControlName="codigo" />

                </div>
                <div class="field col-12 md:col-4">
                    <input id="firstname" pInputText type="text"
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        placeholder="Nombre del Producto" formControlName="nombre_producto" />

                </div>
                <div class="field col-12 md:col-4">
                    <input id="firstname" pInputText type="text"
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        placeholder="Lote" formControlName="lote" />

                </div>
                <div class="field col-12 md:col-4">
                    <input id="firstname" pInputText type="text"
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        placeholder="Numero Caso clinico" formControlName="serie" />

                </div>
                <div class="field col-12 md:col-4">
                    <input id="firstname" pInputText type="text"
                        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                        placeholder="Nombre del Hospital" formControlName="nombre_hospital" />

                </div>

                <div class="field col-12 md:col-4">
                    <p-button icon="pi pi-search" type="submit"
                        styleClass="p-button-rounded p-button-success p-button-text p-button-raised"></p-button>
                </div>
            </form>


        </ng-template>


    </p-toolbar>
    <p-toolbar styleClass="mb-4 gap-1">

        <ng-template pTemplate="center">

            <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcelBack()"></button>

            <p-button label="Productos x hospital" styleClass="p-button-link"
                (click)="exportProductosHospital()"></p-button>
            <p-button label="Productos x institucion" styleClass="p-button-link"
                (click)="exportProductosInstitucion()"></p-button>
            <p-button label="Productos x parte de cuerpo" styleClass="p-button-link"
                (click)="exportProductosCuerpo()"></p-button>



        </ng-template>

    </p-toolbar>
    <p-table [value]="productosPage" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Código</th>
                <th>Producto</th>
                <th>Lote</th>
                <th>Caducidad</th>
                <th colspan="3">Información</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-producto>
            <tr [class.text-red-500]="producto.status == 0">
                <td>
                    <a [class.linea-texto]="producto.status == 0" [class.text-red-500]="producto.status == 0"
                        [routerLink]="['/administrador/producto', producto.id]">
                        {{producto.codigo}}
                    </a>
                </td>
                <td>
                    <span [class.linea-texto]="producto.status == 0">
                        {{producto.nomProducto}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="producto.status == 0">
                        {{producto.lote}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="producto.status == 0">
                        {{producto.caducidad | date:"dd/MM/YYYY"}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="producto.status == 0">
                        {{producto.fk_casoClinico? 'Aplicado': 'No Aplicado'}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="producto.status == 0">
                        {{producto.casoclinico? producto.casoclinico.serie: 'N/A'}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="producto.status == 0">
                        {{producto.casoclinico? producto.casoclinico.nomHospital: 'N/A'}}
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron productos</span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                No. Registros: {{productosPageInformacion.total}}, Total paginas
                {{productosPageInformacion.last_page}}
            </div>
        </ng-template>
    </p-table>
    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"></p-paginator>
    </div>
</section>